export const ANNOUNCEMENTMODALS = new Map([
  [
    'navigation',
    {
      customwidth: false,
      customBannerWidth: false,
      customBannerRadius: false,
      title: 'NAVIGATION.ANNOUNCEMENT.POPUP.TITLE',
      titleCase: 'uppercase',
      showModalHeader: true,
      showClose: true,
      closeColor: 'white',
    },
  ],
  [
    'mandatory',
    {
      customwidth: false,
      customBannerWidth: false,
      customBannerRadius: false,
      title: 'NEW.ACCOUNT.REQUIREMENTS',
      titleCase: 'uppercase',
      showModalHeader: true,
      showClose: false,
      closeColor: '',
    },
  ],
  [
    'pos',
    {
      customwidth: false,
      customBannerWidth: false,
      customBannerRadius: false,
      title: '',
      titleCase: 'uppercase',
      showModalHeader: true,
      showClose: false,
      closeColor: '',
    },
  ],
  [
    'ssologout',
    {
      customwidth: false,
      customBannerWidth: false,
      customBannerRadius: false,
      title: 'AUTO.LOG.OUT.TITLE',
      titleCase: 'uppercase',
      showModalHeader: true,
      showClose: false,
      closeColor: '',
    },
  ],

  [
    'survey',
    {
      customwidth: false,
      customBannerWidth: false,
      customBannerRadius: false,
      title: 'SURVEY.POPUP.TITLE',
      titleCase: 'uppercase',
      showModalHeader: true,
      showClose: true,
      closeColor: 'white',
    },
  ],
  [
    'haloModal',
    {
      customwidth: true,
      customBannerWidth: false,
      customBannerRadius: false,
      title: 'DO.MORE.WITH.HALO.MEDIA',
      titleCase: 'capitalize',
      showModalHeader: true,
      showClose: true,
      closeColor: 'black',
    },
  ],
  [
    'healthandsafety',
    {
      customwidth: true,
      customBannerWidth: false,
      customBannerRadius: false,
      title: 'HEALTH.SAFETY.INTRO.POPUP.HEADER',
      titleCase: 'capitalize',
      showModalHeader: true,
      showClose: true,
      closeColor: 'black',
    },
  ],
  [
    'widgetModal',
    {
      customwidth: true,
      customBannerWidth: false,
      customBannerRadius: false,
      title: 'INTRODUCE.EQUIPMENT.AVAILABILITY.HEADER',
      titleCase: 'capitalize',
      showModalHeader: true,
      showClose: true,
      closeColor: 'black',
    },
  ],
  [
    'subscriptionModal',
    {
      customwidth: true,
      customBannerWidth: false,
      customBannerRadius: false,
      title: 'SUBSCRIPTION.MODAL.HEADER',
      titleCase: 'capitalize',
      showModalHeader: true,
      showClose: true,
      closeColor: 'black',
    },
  ],
  [
    'onboardingModal',
    {
      customwidth: true,
      customBannerWidth: false,
      customBannerRadius: false,
      title: 'OUTDATED.SOFTWARE.VERSION',
      titleCase: 'capitalize',
      showModalHeader: true,
      showClose: true,
      closeColor: 'black',
    },
  ],
  [
    'multisiteModal',
    {
      customwidth: true,
      customBannerWidth: false,
      customBannerRadius: false,
      title: 'INTRODUCE.MANAGE.FACILITIES',
      titleCase: 'capitalize',
      showModalHeader: true,
      showClose: true,
      closeColor: 'black',
    },
  ],
  [
    'lfodEnabledEquipment',
    {
      customwidth: true,
      customBannerWidth: false,
      customBannerRadius: false,
      title: 'LFOD.POPUP.HEADER',
      titleCase: 'capitalize',
      showModalHeader: true,
      showClose: true,
      closeColor: 'black',
    },
  ],
  [
    'digitalCoach',
    {
      customwidth: true,
      customBannerWidth: false,
      customBannerRadius: false,
      title: 'DIGITAL.COACH.INTRO.POPUP.HEADER',
      titleCase: 'capitalize',
      showModalHeader: true,
      showClose: true,
      closeColor: 'black',
    },
  ],
  [
    'customLibrary',
    {
      customwidth: true,
      customBannerWidth: false,
      customBannerRadius: false,
      title: 'CUSTOM.LIBRARY.POPUP.HEADER',
      titleCase: 'capitalize',
      showModalHeader: true,
      showClose: true,
      closeColor: 'black',
    },
  ],
  [
    'hasCmsLegalReconsent',
    {
      customwidth: true,
      customBannerWidth: false,
      customBannerRadius: false,
      title: 'CUSTOM.LIBRARY.МОDAL.TITLE',
      titleCase: 'capitalize',
      showModalHeader: true,
      showClose: false,
      closeColor: 'black',
    },
  ],
  [
    'fcAnnouncementBanner',
    {
      customwidth: false,
      customBannerWidth: true,
      customBannerRadius: true,
      title: '',
      titleCase: 'capitalize',
      showModalHeader: false,
      showClose: true,
      closeColor: 'black',
    },
  ],
  [
    'fcSessionExpiry',
    {
      customwidth: false,
      customBannerWidth: true,
      customBannerRadius: true,
      title: '',
      titleCase: 'capitalize',
      showModalHeader: false,
      showClose: true,
      closeColor: 'black',
    },
  ],
]);
